import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, getUtility, Icon, SummaryInfo } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Paper, Tab, Tabs, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableModal from 'src/pages/AllocationTablesPage/AllocationUtility/TableModal';
import useAllocationUtilityStyles from 'src/pages/AllocationTablesPage/AllocationUtility/styles';
import { useStore } from 'src/stores';
const AllocationHistory = observer(() => {
  var _store$utilityProvide, _store$utilityProvide2, _utility$allocations$;
  const classes = useAllocationUtilityStyles();
  const history = useLocation();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedBillingCycleId = _useState6[0],
    setSelectedBillingCycleId = _useState6[1];
  const urlParams = new URLSearchParams(history.search);
  const allocationCycleId = urlParams.get('allocationCycleId');
  const tabs = store.allocations.tabs;
  const _ref = store.allocations.historyData || {},
    propertyId = _ref.propertyId,
    utilityId = _ref.utilityId;
  const id = selectedBillingCycleId + propertyId + utilityId;
  const historyPreviewSelectedTab = store.allocations.historyPreviewSelectedTab || tabs[0];
  const queue = store.allocations.queue;
  const setHistoryPreviewSelectedTab = store.allocations.setHistoryPreviewSelectedTab;
  const utility = store.allocations.utilityById.get(selectedBillingCycleId + utilityId) || {};
  const utilityData = getUtility((_store$utilityProvide = store.utilityProviders.utilities.get(utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName);
  const getBillingCycles = async data => {
    const resp = await store.allocations.getBillingCyclesAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (!propertyId) return;
    const allocationCycleIdForFetch = historyPreviewSelectedTab ? store.allocations.cyclesIds.get(historyPreviewSelectedTab) : allocationCycleId;
    const billingCyclesFetched = store.allocations.billingCyclesFetched.get(allocationCycleIdForFetch + propertyId);
    if (!billingCyclesFetched) {
      setIsLoading(id);
      getBillingCycles({
        allocationCycleId: allocationCycleIdForFetch,
        propertyId
      }).then(resp => {
        var _resp$response$;
        if (!resp) return;
        const billingCycleId = resp === null || resp === void 0 || (_resp$response$ = resp.response[0]) === null || _resp$response$ === void 0 ? void 0 : _resp$response$.id;
        setSelectedBillingCycleId(billingCycleId);
        if (store.allocations.utilityById.get(billingCycleId + utilityId)) return;
        store.allocations.addToQueue({
          billingCycleId,
          id,
          propertyId,
          utilityId
        });
      });
    }
  }, [historyPreviewSelectedTab]);
  useEffect(() => {
    if (!queue.find(item => item.id === id)) setIsLoading('');
  }, [queue]);
  const handleTabChange = (e, value) => setHistoryPreviewSelectedTab(value);
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(SummaryInfo, {
    allocationMethod: utility === null || utility === void 0 ? void 0 : utility.allocationMethod,
    children: tabs.length > 0 ? /*#__PURE__*/React.createElement(Tabs, {
      "aria-label": "tabs navigation",
      onChange: handleTabChange,
      type: "navigation",
      value: historyPreviewSelectedTab
    }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
      key: tab,
      label: tab,
      value: tab
    }))) : null,
    providerName: (_store$utilityProvide2 = store.utilityProviders.utilities.get(utilityId)) === null || _store$utilityProvide2 === void 0 ? void 0 : _store$utilityProvide2.providerName,
    showRecovery: true,
    summaryData: {
      'Allocated:': "$".concat((utility === null || utility === void 0 ? void 0 : utility.allocated) || 0),
      'Bill total:': "$".concat((utility === null || utility === void 0 ? void 0 : utility.billTotal) || 0),
      'Deductions:': "".concat((utility === null || utility === void 0 ? void 0 : utility.deductions) || 0, "%"),
      'Recovery:': "".concat((utility === null || utility === void 0 ? void 0 : utility.recovery) || 0, "%")
    },
    utilityType: utilityData.title
  }), /*#__PURE__*/React.createElement(Accordion, {
    className: classes.detailsTable,
    expanded: isExpanded
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-details",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-details",
    onClick: () => setIsExpanded(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_ratio_billed_units_table')), /*#__PURE__*/React.createElement("div", {
    className: classes.totalSummary
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.ratio_billed_total'), "\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "$", utility.ratioBilledTotal || 0)))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(TableModal, {
    allocations: utility === null || utility === void 0 ? void 0 : utility.allocations,
    key: (utility === null || utility === void 0 ? void 0 : utility.allocations) && store.account.profilesFullName.get(utility === null || utility === void 0 || (_utility$allocations$ = utility.allocations[0]) === null || _utility$allocations$ === void 0 ? void 0 : _utility$allocations$.residentAccountId)
  }))));
});
export default AllocationHistory;